import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root' // disponível em toda a aplicação
})
export class SharedService {
  private isAdminSource = new BehaviorSubject<boolean>(false);
  isAdmin$ = this.isAdminSource.asObservable();

  private sidebarToggleSource = new Subject<void>();
  sidebarToggle$ = this.sidebarToggleSource.asObservable();

  setVariavel(valor: boolean) {
    this.isAdminSource.next(valor);
  }

  toggleSidebar(): void {
    this.sidebarToggleSource.next();
  }
}
